"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class SchoolSyncExpiredError extends client_library_1.ExtendableError {
    constructor(schoolId) {
        super(`School sync has expired for school: ${schoolId}`);
    }
}
exports.default = SchoolSyncExpiredError;
//# sourceMappingURL=SchoolSyncExpiredError.js.map